import * as Yup from "yup";
import {
    dateCantBeInFuture,
    dateIsBefore
} from "./validationFunctions";

export const discloseSensitiveInfoValidations = (section, languageText) => {
    return Yup.object().shape({

        sensitiveInfo: Yup.array()
            .required(
                () =>
                    languageText.ErrorChecking.ValidatorText.MissingRelease
            )


    });

}
